<template>
  <div class="">
    <a-table
      size="middle"
      :columns="columns"
      :data-source="tableData"
      :loading="loading"
      :row-key="(record, index) => record.id"
      bordered
      :pagination="false"
      :locale="{ emptyText: '暂无数据' }"
    >
      <template slot="sort" slot-scope="text, record, index">
        {{ index + 1 }}
      </template>
      <template slot="name" slot-scope="text, record">
        <span v-if="record.required" class="text-color-orange">*</span>
        {{ text }}
      </template>
      <template slot="remark" slot-scope="text, record">
        {{ text }}
        <a class="remark-a" v-if="record.template" @click="downloadFile(record.template)">
          模板下载
        </a>
      </template>
      <template slot="oper" slot-scope="text, record, index">
        <fileUpload
          accept=".pdf,.PDF,.jpg,.JPG,.png,.PNG,.bmp,.BMP"
          className="fnc-file"
          :ref="'bankFile' + record.id"
          :paramObj.sync="bankFileParam"
          @uploadOk="uploadOkRelated($event, record, index)"
          @beforeFileUpload="beforeUploadRelated($event, record, index)"
          @handleFileRemove="handleFileRemove($event, record, index)"
          :removeaction="true"
          :hideButtonHasFiles="true"
          name="file"
        />
      </template>
    </a-table>
    <div class="text-color-orange" style="margin-top:16px;">
      <div v-for="(remark, index) in bankFilingRemark" :key="index" :style="index > 0 ? 'padding-left:29px': ''">
        <span v-if="index==0">注：</span>{{index + 1}}、{{remark}}
      </div>
    </div>
  </div>
</template>

<script>
import { fileSaveAPI, fileQueryAPI } from "@/api/file.js";

export default {
  props: {
    params: {
      type: Object
    },
  },
  components: {},
  data() {
    return {
      loading: false,
      tableData: [],
      columns: [
        {
          title: "序号",
          dataIndex: "sort",
          scopedSlots: { customRender: "sort" }
        },
        {
          title: "文件名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" }
        },
        {
          title: "相关说明",
          dataIndex: "remark",
          scopedSlots: { customRender: "remark" }
        },
        {
          title: "操作",
          dataIndex: "oper",
          width: "300px",
          scopedSlots: { customRender: "oper" }
        }
      ],
      bankFileParam: {
        app: "portal-pc",
        module: "bankadd",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: "",
        mdlId: "bankadd",
        fileTpCd: 5,
        fileSubTpCd: ""
      },
      cstId: this.$store.getters["home/getUserObj"].cstIds[0] || "",
    };
  },
  computed: {
    tblBlId(){
      return this.cstId + "_" + this.$route.query.bankCd
    },
    bankCd(){
      let bankCd = this.$route.query.bankCd;
      return this.dict.bankListMap[bankCd] || "beijing"; //所有银行先和默认beijing
    },
    bankFilingRemark(){
      return this.dict.bankFilingRemark[this.bankCd] || []
    }
  },
  methods: {
    initData() {
      this.tableData = this.dict.bankFilingFileList[this.bankCd] || this.dict.bankFilingFileList[this.bankCd];
      this.queryFile();
    },
    queryFile(){
      this.loading = true;
      fileQueryAPI({tblBlId: this.tblBlId, fileTpCd: '5'}).then(res => {
        let resData = res.data || [];
        resData.forEach((file) => {
          this.$refs['bankFile' + file.fileSubTpCd].setFileList({
            name: file.fileNm,
            size: file.fileSize,
            uid: file.fileId,
            fileExpdNm: file.fileExpdNm,
            fileRte: file.fileRte,
            tblBlId: file.tblBlId
          })
          this.tableData.forEach((item,idx) => {
            if(item.id == file.fileSubTpCd){
              this.tableData[idx].fileId = file.fileId;
              return;
            }
          })
        });
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    // 上传前处理参数
    beforeUploadRelated(fileList, record, index) {
      this.bankFileParam = {
        app: "portal-pc",
        module: "bankadd",
        user: this.$store.getters["home/getUserHeader"].realname,
        tblBlId: this.tblBlId,
        bizId: this.tblBlId,
        mdlId: "bankadd",
        fileTpCd: 5,
        fileSubTpCd: record.id
      };
      this.$nextTick(() => {
        this.$refs["bankFile" + record.id].setParams(this.bankFileParam);
      });
    },
    // 上传后保存
    uploadOkRelated(resList, record, index) {
      let cstId = this.$store.getters["home/getUserObj"].cstIds[0] || "";
      let data = resList[0];
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.tblBlId,
        bizId: this.tblBlId,
        mdlId: "bankadd",
        fileTpCd: 5,
        fileSubTpCd: record.id
      };
      fileSaveAPI(param)
        .then(res => {
          record.fileId = res.data.fileId;
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleFileRemove(fileList, record, index) {
      this.tableData[index].fileId = undefined;
    },
    downloadFile(template){
      window.open(template.url);
    },
    check() {
      return new Promise((resolve, reject) => {
        let errItem = this.tableData.find(i => i.required && !i.fileId);
        console.log(errItem);
        if (errItem) {
          this.$message.error("请上传必传文件：" + errItem.name);
          reject();
          return;
        }
        resolve({
          ...this.params,
          cstId: this.cstId,
          bankCd: this.$route.query.bankCd,
          tenantOrgCode: this.$route.query.tenantOrgCode,
          tenantId: this.$route.query.tenantId
        });
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>
<style scoped>
.remark-a {
  margin: 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bank/bank-step-supplement.vue